import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { alignUrlToPageHost } from "../utils/local-api-host";

@Injectable()
export class LocalApiHostInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const url = alignUrlToPageHost(req.url);

    return next.handle(url === req.url ? req : req.clone({ url }));
  }
}
